// import React from 'react';
// import { X } from 'lucide-react';

// const CustomNotificationStatic = ({ onClose }) => {
//   return (
//     <div style={{ padding: '20px', height: '100%', display: 'flex', flexDirection: 'column' }}>
//       {/* Header */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '20px',
//         borderBottom: '2px solid #0056b3',
//         paddingBottom: '10px'
//       }}>
//         <h3 style={{ margin: 0, color: '#0056b3' }}>Custom Notifications</h3>
//         <button
//           onClick={onClose}
//           style={{
//             background: 'transparent',
//             border: 'none',
//             cursor: 'pointer',
//             padding: '5px',
//           }}
//         >
//           <X size={24} color="#333" />
//         </button>
//       </div>

//       {/* Content */}
//       <div style={{ flex: 1, overflowY: 'auto' }}>
//         <div style={{
//           background: '#f8f9fa',
//           padding: '15px',
//           borderRadius: '8px',
//           marginBottom: '20px',
//           border: '1px solid #dee2e6'
//         }}>
//           <h5 style={{ color: '#0056b3', marginBottom: '10px', fontSize: '16px' }}>
//             Ã°Å¸â€œÂ¢ How to Send Custom Notifications
//           </h5>
//           <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.6', margin: 0 }}>
//             Use this feature to send personalized notifications to specific users or groups.
//             Fill in the required fields and customize your message.
//           </p>
//         </div>

//         <div style={{ marginBottom: '25px' }}>
//           <h6 style={{ color: '#333', marginBottom: '12px', fontWeight: 'bold' }}>
//             Recent Custom Notifications
//           </h6>

//           {/* Notification Item 1 */}
//           <div style={{
//             background: '#fff',
//             padding: '12px',
//             borderRadius: '6px',
//             marginBottom: '12px',
//             border: '1px solid #e0e0e0',
//             boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               marginBottom: '8px'
//             }}>
//               <span style={{
//                 fontWeight: 'bold',
//                 color: '#0056b3',
//                 fontSize: '14px'
//               }}>
//                 System Maintenance Alert
//               </span>
//               <span style={{
//                 background: '#28a745',
//                 color: '#fff',
//                 padding: '2px 8px',
//                 borderRadius: '4px',
//                 fontSize: '11px',
//                 fontWeight: 'bold'
//               }}>
//                 SENT
//               </span>
//             </div>
//             <p style={{
//               color: '#666',
//               fontSize: '13px',
//               margin: '8px 0',
//               lineHeight: '1.5'
//             }}>
//               Scheduled maintenance on December 20th from 2:00 AM to 4:00 AM IST.
//             </p>
//             <small style={{ color: '#999' }}>
//               Sent to: All Users Ã¢â‚¬Â¢ December 15, 2025
//             </small>
//           </div>

//           {/* Notification Item 2 */}
//           <div style={{
//             background: '#fff',
//             padding: '12px',
//             borderRadius: '6px',
//             marginBottom: '12px',
//             border: '1px solid #e0e0e0',
//             boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               marginBottom: '8px'
//             }}>
//               <span style={{
//                 fontWeight: 'bold',
//                 color: '#0056b3',
//                 fontSize: '14px'
//               }}>
//                 New Feature Launch
//               </span>
//               <span style={{
//                 background: '#28a745',
//                 color: '#fff',
//                 padding: '2px 8px',
//                 borderRadius: '4px',
//                 fontSize: '11px',
//                 fontWeight: 'bold'
//               }}>
//                 SENT
//               </span>
//             </div>
//             <p style={{
//               color: '#666',
//               fontSize: '13px',
//               margin: '8px 0',
//               lineHeight: '1.5'
//             }}>
//               Check out our new analytics dashboard with real-time insights!
//             </p>
//             <small style={{ color: '#999' }}>
//               Sent to: Premium Users Ã¢â‚¬Â¢ December 12, 2025
//             </small>
//           </div>

//           {/* Notification Item 3 */}
//           <div style={{
//             background: '#fff',
//             padding: '12px',
//             borderRadius: '6px',
//             marginBottom: '12px',
//             border: '1px solid #e0e0e0',
//             boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               marginBottom: '8px'
//             }}>
//               <span style={{
//                 fontWeight: 'bold',
//                 color: '#0056b3',
//                 fontSize: '14px'
//               }}>
//                 Payment Reminder
//               </span>
//               <span style={{
//                 background: '#ffc107',
//                 color: '#000',
//                 padding: '2px 8px',
//                 borderRadius: '4px',
//                 fontSize: '11px',
//                 fontWeight: 'bold'
//               }}>
//                 SCHEDULED
//               </span>
//             </div>
//             <p style={{
//               color: '#666',
//               fontSize: '13px',
//               margin: '8px 0',
//               lineHeight: '1.5'
//             }}>
//               Your subscription renewal is due on December 25th. Please update payment method.
//             </p>
//             <small style={{ color: '#999' }}>
//               To be sent: Active Subscribers Ã¢â‚¬Â¢ December 18, 2025
//             </small>
//           </div>

//           {/* Notification Item 4 */}
//           <div style={{
//             background: '#fff',
//             padding: '12px',
//             borderRadius: '6px',
//             marginBottom: '12px',
//             border: '1px solid #e0e0e0',
//             boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               marginBottom: '8px'
//             }}>
//               <span style={{
//                 fontWeight: 'bold',
//                 color: '#0056b3',
//                 fontSize: '14px'
//               }}>
//                 Holiday Greetings
//               </span>
//               <span style={{
//                 background: '#28a745',
//                 color: '#fff',
//                 padding: '2px 8px',
//                 borderRadius: '4px',
//                 fontSize: '11px',
//                 fontWeight: 'bold'
//               }}>
//                 SENT
//               </span>
//             </div>
//             <p style={{
//               color: '#666',
//               fontSize: '13px',
//               margin: '8px 0',
//               lineHeight: '1.5'
//             }}>
//               Wishing you and your team a wonderful holiday season!
//             </p>
//             <small style={{ color: '#999' }}>
//               Sent to: All Users Ã¢â‚¬Â¢ December 10, 2025
//             </small>
//           </div>
//         </div>

//         <div style={{
//           background: '#e7f3ff',
//           padding: '12px',
//           borderRadius: '6px',
//           border: '1px solid #b3d9ff',
//           marginTop: '20px'
//         }}>
//           <h6 style={{
//             color: '#0056b3',
//             marginBottom: '8px',
//             fontSize: '14px',
//             fontWeight: 'bold'
//           }}>
//             Ã°Å¸â€™Â¡ Tips for Effective Notifications
//           </h6>
//           <ul style={{
//             color: '#666',
//             fontSize: '13px',
//             lineHeight: '1.6',
//             margin: '8px 0 0 0',
//             paddingLeft: '20px'
//           }}>
//             <li>Keep messages clear and concise</li>
//             <li>Include relevant action items</li>
//             <li>Target specific user groups</li>
//             <li>Schedule during optimal times</li>
//           </ul>
//         </div>
//       </div>

//       {/* Footer */}
//       <div style={{
//         marginTop: '20px',
//         paddingTop: '15px',
//         borderTop: '1px solid #eee',
//         textAlign: 'center'
//       }}>
//         <button
//           onClick={onClose}
//           style={{
//             background: '#0056b3',
//             color: '#fff',
//             border: 'none',
//             padding: '10px 24px',
//             borderRadius: '6px',
//             cursor: 'pointer',
//             fontSize: '14px',
//             fontWeight: 'bold'
//           }}
//         >
//           Create New Notification
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CustomNotificationStatic;

// dynamic code -----------------------------------------

// import React, { useEffect, useState } from 'react';
// import { X } from 'lucide-react';
// import axios from 'axios';
// import moment from 'moment';
// import Loader from 'components/common/Loader';
// import { APP_TOKEN } from '../../../../constants';

// const CustomNotificationStatic = ({ onClose }) => {
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const BASE_URL = process.env.REACT_APP_REST_API_ENDPOINT;

//   const fetchCustomNotifications = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const userData = JSON.parse(localStorage.getItem(APP_TOKEN));

//       if (!userData || !userData.token) {
//         setError('Authentication token not found');
//         setLoading(false);
//         return;
//       }

//       console.log('Ã°Å¸â€Â§ Fetching notifications from:', BASE_URL);
//       console.log(`Ã°Å¸â€â€˜ Token: ${userData.token.substring(0, 20)}...`);

//       const response = await axios.get(
//         `${BASE_URL}notification/getall?typeName=customNotification&pageNumber=1&pageSize=1000`,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${userData.token}`,
//           },
//         }
//       );

//       console.log('Ã¢Å“â€¦ API Response:', response.data);

//       if (response.data && response.data.message === 'Success') {
//         // Filter notifications that have images
//         const notificationsWithImages = response.data.data.notifications.filter(
//           (item) => item.image && item.image.trim() !== ''
//         );
//         console.log('Ã¢Å“â€¦ Notifications with images:', notificationsWithImages.length);
//         setNotifications(notificationsWithImages);
//       } else {
//         setError('Failed to fetch notifications');
//       }
//     } catch (err) {
//       console.error('Ã¢ÂÅ’ Error fetching Custom Notifications:', err);

//       if (err.response) {
//         console.error('Server Error:', err.response.data);
//         setError(err.response.data?.message || 'Server error occurred');
//       } else if (err.request) {
//         console.error('Network Error:', err.request);
//         setError('Network error - Unable to reach server');
//       } else {
//         console.error('Error:', err.message);
//         setError(err.message || 'Something went wrong');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCustomNotifications();
//   }, []);

//   const formatDate = (timestamp) => {
//     return moment(timestamp).format('MMMM DD, YYYY');
//   };

//   return (
//     <div style={{ padding: '20px', height: '100%', display: 'flex', flexDirection: 'column' }}>
//       {/* Header */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '20px',
//         borderBottom: '2px solid #0056b3',
//         paddingBottom: '10px'
//       }}>
//         <h3 style={{ margin: 0, color: 'black' }}>Custom Notifications</h3>
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             background: 'transparent',
//             border: 'none',
//             cursor: 'pointer',
//             padding: '5px',
//           }}
//         >
//           <X size={24} color="#333" />
//         </button>
//       </div>

//       {/* Content */}
//       <div style={{ flex: 1, overflowY: 'auto' }}>
//         {loading ? (
//           <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
//             <Loader />
//           </div>
//         ) : error ? (
//           <div style={{
//             textAlign: 'center',
//             padding: '40px',
//             color: '#dc3545',
//             background: '#f8d7da',
//             borderRadius: '8px',
//             border: '1px solid #f5c6cb'
//           }}>
//             <p style={{ margin: 0, fontWeight: 'bold' }}>Error Loading Notifications</p>
//             <p style={{ margin: '8px 0 0 0', fontSize: '14px' }}>{error}</p>
//             <button
//               type="button"
//               onClick={fetchCustomNotifications}
//               style={{
//                 marginTop: '12px',
//                 background: '#dc3545',
//                 color: '#fff',
//                 border: 'none',
//                 padding: '8px 16px',
//                 borderRadius: '6px',
//                 cursor: 'pointer',
//                 fontSize: '14px',
//                 fontWeight: 'bold'
//               }}
//             >
//               Retry
//             </button>
//           </div>
//         ) : notifications.length === 0 ? (
//           <div style={{
//             textAlign: 'center',
//             padding: '40px',
//             color: '#6c757d',
//             background: '#f8f9fa',
//             borderRadius: '8px',
//             border: '1px solid #dee2e6'
//           }}>
//             <p style={{ margin: 0, fontSize: '16px' }}>Ã°Å¸â€œÂ­ No custom notifications available</p>
//             <p style={{ margin: '8px 0 0 0', fontSize: '14px' }}>No notifications with images found!</p>
//           </div>
//         ) : (
//           <div style={{ marginBottom: '25px' }}>
//             <h6 style={{ color: '#333', marginBottom: '12px', fontWeight: 'bold' }}>
//               {`Recent Custom Notifications (${notifications.length})`}
//             </h6>

//             {notifications.map((notification) => (
//               <div
//                 key={notification.typeId + notification.createdAt}
//                 style={{
//                   background: '#fff',
//                   padding: '12px',
//                   borderRadius: '8px',
//                   marginBottom: '15px',
//                   border: '1px solid #e0e0e0',
//                   boxShadow: '0 2px 4px rgba(0,0,0,0.08)'
//                 }}
//               >
//                 {/* Title */}
//                 <div style={{
//                   marginBottom: '12px',
//                   paddingBottom: '8px',
//                   borderBottom: '1px solid #f0f0f0'
//                 }}>
//                   <h5 style={{
//                     fontWeight: 'bold',
//                     color: '#0056b3',
//                     fontSize: '15px',
//                     margin: 0,
//                     wordBreak: 'break-word'
//                   }}>
//                     {notification.title}
//                   </h5>
//                   <small style={{
//                     color: '#999',
//                     fontSize: '12px',
//                     marginTop: '4px',
//                     display: 'block'
//                   }}>
//                     {formatDate(notification.createdAt)}
//                   </small>
//                 </div>

//                 {/* Image */}
//                 {notification.image && (
//                   <div style={{ marginBottom: '12px' }}>
//                     <img
//                       src={notification.image}
//                       alt={notification.title}
//                       style={{
//                         width: '100%',
//                         maxHeight: '200px',
//                         objectFit: 'cover',
//                         borderRadius: '6px',
//                         border: '1px solid #dee2e6'
//                       }}
//                       onError={(e) => {
//                         e.target.style.display = 'none';
//                       }}
//                     />
//                   </div>
//                 )}

//                 {/* Message */}
//                 <p style={{
//                   color: '#666',
//                   fontSize: '13px',
//                   margin: 0,
//                   lineHeight: '1.6',
//                   whiteSpace: 'pre-wrap',
//                   wordBreak: 'break-word'
//                 }}>
//                   {notification.message}
//                 </p>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Tips Section - Always visible */}
//         {!loading && !error && (
//           <div style={{
//             background: '#e7f3ff',
//             padding: '12px',
//             borderRadius: '6px',
//             border: '1px solid #b3d9ff',
//             marginTop: '20px'
//           }}>
//             <h6 style={{
//               color: '#0056b3',
//               marginBottom: '8px',
//               fontSize: '14px',
//               fontWeight: 'bold'
//             }}>
//               Ã°Å¸â€™Â¡ About Custom Notifications
//             </h6>
//             <p style={{
//               color: '#666',
//               fontSize: '13px',
//               lineHeight: '1.6',
//               margin: 0
//             }}>
//               These are personalized notifications sent to users. Only notifications with images are displayed here for better visual experience.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Footer */}
//       <div style={{
//         marginTop: '20px',
//         paddingTop: '15px',
//         borderTop: '1px solid #eee',
//         textAlign: 'center'
//       }}>
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             background: '#0056b3',
//             color: '#fff',
//             border: 'none',
//             padding: '10px 24px',
//             borderRadius: '6px',
//             cursor: 'pointer',
//             fontSize: '14px',
//             fontWeight: 'bold'
//           }}
//         >
//           Close
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CustomNotificationStatic;

// this code is for icon in notification side bar jiskio mene hata diya hai -------------------------------------------------------------------------------------------------------------------------------

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import moment from 'moment';
// import { X } from 'lucide-react';
// import Loader from 'components/common/Loader';
// import { APP_TOKEN } from '../../../../constants';

// // Define styles before component to fix no-use-before-define
// const headerStyle = {
//   padding: '12px 10px',
//   textAlign: 'left',
//   fontWeight: 600,
//   fontSize: '13px',
//   color: '#495057',
//   borderBottom: '2px solid #dee2e6',
// };

// const cellStyle = {
//   padding: '12px 10px',
//   verticalAlign: 'middle',
//   color: '#495057',
// };

// const CustomNotificationTable = ({ onClose }) => {
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [expandedRows, setExpandedRows] = useState([]);

//   const BASE_URL = process.env.REACT_APP_GRAPHQL_ENDPOINT;

//   const fetchCustomNotifications = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const userData = JSON.parse(localStorage.getItem(APP_TOKEN));
//       if (!userData?.token) {
//         setError('Authentication token not found');
//         return;
//       }

//       const response = await axios.post(
//         `${BASE_URL}`,
//         {
//           query: `query customNotifications($pageNo: Int, $pageSize: Int, $sortCol: String, $sortDirection: String, $pagination: Boolean) {
//             customNotifications(
//               pageNo: $pageNo
//               pageSize: $pageSize
//               sortCol: $sortCol
//               sortDirection: $sortDirection
//               pagination: $pagination
//             ) {
//               customNotifications {
//                 id
//                 title
//                 message
//                 platformType
//                 notificationType
//                 image
//                 video
//                 createdAt
//                 stats {
//                   delivered
//                   opened
//                   dismissed
//                 }
//               }
//               totalPages
//               totalCount
//             }
//           }`,
//           variables: {
//             pageNo: 1,
//             pageSize: 10,
//             sortCol: 'createdAt',
//             sortDirection: 'DESC',
//             pagination: true,
//           },
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${userData.token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       if (response.data?.data?.customNotifications) {
//         setNotifications(
//           response.data.data.customNotifications.customNotifications || []
//         );
//       } else {
//         setError('Failed to fetch notifications');
//       }
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//           err.response?.data?.errors?.[0]?.message ||
//           'Something went wrong'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCustomNotifications();
//   }, []);

//   const formatDate = (timestamp) =>
//     moment(timestamp).format('DD MMM YYYY');

//   const toggleRowExpansion = (id) => {
//     setExpandedRows((prev) =>
//       prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
//     );
//   };

//   // Handle keyboard events for accessibility
//   const handleKeyDown = (e, callback) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       callback();
//     }
//   };

//   return (
//     <div
//       style={{
//         position: 'fixed',
//         right: 0,
//         top: 0,
//         width: '70%',
//         height: '100vh',
//         background: '#fff',
//         boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
//         display: 'flex',
//         flexDirection: 'column',
//         zIndex: 1000,
//         fontFamily: "'Work Sans', sans-serif",
//       }}
//     >
//       {/* Header */}
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           borderBottom: '2px solid #e0e0e0',
//           padding: '15px 20px',
//           background: '#f8f9fa',
//         }}
//       >
//         <h2 style={{ margin: 0, fontWeight: 600, fontSize: '18px' }}>
//           Custom Notifications
//         </h2>
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             border: 'none',
//             background: 'transparent',
//             cursor: 'pointer',
//             padding: '5px',
//           }}
//         >
//           <X size={22} />
//         </button>
//       </div>

//       {/* Content */}
//       <div style={{ flex: 1, overflowY: 'auto', padding: '15px' }}>
//         {loading ? (
//           <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
//             <Loader />
//           </div>
//         ) : error ? (
//           <p style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
//             {error}
//           </p>
//         ) : notifications.length === 0 ? (
//           <p style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
//             No notifications found
//           </p>
//         ) : (
//           <div style={{ overflowX: 'auto' }}>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '13px',
//               }}
//             >
//               <thead>
//                 <tr style={{ background: '#f1f3f5' }}>
//                   <th style={headerStyle}>S.No.</th>
//                   <th style={headerStyle}>Date</th>
//                   <th style={headerStyle}>Title</th>
//                   <th style={headerStyle}>Message</th>
//                   <th style={headerStyle}>Stats</th>
//                   <th style={headerStyle}>Image</th>
//                   <th style={headerStyle}>Platform</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {notifications.map((item, index) => (
//                   <tr
//                     key={item.id}
//                     style={{
//                       borderBottom: '1px solid #e9ecef',
//                       background: index % 2 === 0 ? '#fff' : '#fafafa',
//                     }}
//                   >
//                     <td style={cellStyle}>{index + 1}</td>
//                     <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>
//                       {formatDate(item.createdAt)}
//                     </td>
//                     <td style={{ ...cellStyle, fontWeight: 500 }}>
//                       {item.title}
//                     </td>
//                     <td style={{ ...cellStyle, maxWidth: '250px' }}>
//                       <button
//                         type="button"
//                         style={{
//                           maxHeight: expandedRows.includes(item.id) ? 'none' : '60px',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                           display: '-webkit-box',
//                           WebkitLineClamp: expandedRows.includes(item.id) ? 'unset' : 3,
//                           WebkitBoxOrient: 'vertical',
//                           cursor: 'pointer',
//                           border: 'none',
//                           background: 'transparent',
//                           padding: 0,
//                           textAlign: 'left',
//                           width: '100%',
//                           font: 'inherit',
//                           color: 'inherit',
//                         }}
//                         onClick={() => toggleRowExpansion(item.id)}
//                         onKeyDown={(e) => handleKeyDown(e, () => toggleRowExpansion(item.id))}
//                         title="Click to expand/collapse"
//                       >
//                         {item.message}
//                       </button>
//                     </td>
//                     <td style={cellStyle}>
//                       <div style={{ fontSize: '13px' }}>
//                         <div>
//                           <strong>Delivered:</strong> {item.stats.delivered}
//                         </div>
//                         <div>
//                           <strong>Opened:</strong> {item.stats.opened}
//                         </div>
//                         <div>
//                           <strong>Dismissed:</strong> {item.stats.dismissed}
//                         </div>
//                       </div>
//                     </td>
//                     <td style={{ ...cellStyle, textAlign: 'center' }}>
//                       {item.image && item.image.trim() !== '' ? (
//                         <button
//                           type="button"
//                           onClick={() => window.open(item.image, '_blank')}
//                           onKeyDown={(e) => handleKeyDown(e, () => window.open(item.image, '_blank'))}
//                           style={{
//                             border: 'none',
//                             background: 'transparent',
//                             padding: 0,
//                             cursor: 'pointer',
//                           }}
//                         >
//                           <img
//                             src={item.image}
//                             alt={item.title}
//                             style={{
//                               width: '50px',
//                               height: '50px',
//                               objectFit: 'cover',
//                               borderRadius: '4px',
//                             }}
//                             onError={(e) => {
//                               e.target.style.display = 'none';
//                             }}
//                           />
//                         </button>
//                       ) : (
//                         <span style={{ color: '#999', fontSize: '11px' }}>
//                           No Image
//                         </span>
//                       )}
//                     </td>
//                     <td style={cellStyle}>
//                       <span
//                         style={{
//                           padding: '4px 8px',
//                           borderRadius: '4px',
//                           background:
//                             item.platformType === 'WEB'
//                               ? '#e3f2fd'
//                               : item.platformType === 'MOBILE'
//                               ? '#f3e5f5'
//                               : '#fff3e0',
//                           color:
//                             item.platformType === 'WEB'
//                               ? '#1565c0'
//                               : item.platformType === 'MOBILE'
//                               ? '#6a1b9a'
//                               : '#e65100',
//                           fontSize: '11px',
//                           fontWeight: 500,
//                         }}
//                       >
//                         {item.platformType}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CustomNotificationTable;

// this is code is for analyztics side bar jisko add kiya hai ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import moment from 'moment';
import { FaChevronDown } from 'react-icons/fa6';
import Loader from 'components/common/Loader';
import { APP_TOKEN } from '../../../../constants';

// Define styles before component to fix no-use-before-define
const headerStyle = {
  padding: '12px 10px',
  textAlign: 'left',
  fontWeight: 600,
  fontSize: '13px',
  color: '#495057',
  borderBottom: '2px solid #dee2e6',
};

const cellStyle = {
  padding: '12px 10px',
  verticalAlign: 'middle',
  color: '#495057',
};

const CustomNotificationTable = ({ isDrawer = true }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedMobileCardId, setExpandedMobileCardId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const statsTooltip = [
    'Delivered: Notification reached device.',
    'Device may or may not open it.',
    '',
    'Opened: User tapped the notification.',
    'App opened from the notification.',
    '',
    'Seen: Message viewed inside the app.',
    'Counted when screen is shown.',
    '',
    'Dismissed: User cleared without opening.',
    'Swiped away or closed.',
  ].join('\n');

  const BASE_URL = process.env.REACT_APP_GRAPHQL_ENDPOINT;

  const fetchCustomNotifications = useCallback(async (
    pageNo = currentPage,
    size = pageSize,
  ) => {
    try {
      setLoading(true);
      setError(null);

      const userData = JSON.parse(localStorage.getItem(APP_TOKEN));
      if (!userData?.token) {
        setError('Authentication token not found');
        return;
      }

      const response = await axios.post(
        `${BASE_URL}`,
        {
          query: `query customNotifications($pageNo: Int, $pageSize: Int, $sortCol: String, $sortDirection: String, $pagination: Boolean) {
            customNotifications(
              pageNo: $pageNo
              pageSize: $pageSize
              sortCol: $sortCol
              sortDirection: $sortDirection
              pagination: $pagination
            ) {
              customNotifications {
                id
                title
                message
                platformType
                notificationType
                image
                video
                createdAt
                scheduledAt
                isSent
                stats {
                  delivered
                  opened
                  dismissed
                  seen
                }
              }
              totalPages
              totalCount
            }
          }`,
          variables: {
            pageNo,
            pageSize: size,
            sortCol: 'createdAt',
            sortDirection: 'DESC',
            pagination: true,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.data?.data?.customNotifications) {
        const data = response.data.data.customNotifications;
        setNotifications(data.customNotifications || []);
        setExpandedRows([]);
        const safeTotalCount = Number(data.totalCount) || 0;
        const safeTotalPages =
          Number(data.totalPages) || Math.ceil(safeTotalCount / size) || 0;
        setTotalPages(safeTotalPages);
      } else {
        setError('Failed to fetch notifications');
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data?.errors?.[0]?.message ||
          'Something went wrong',
      );
    } finally {
      setLoading(false);
    }
  }, [currentPage, pageSize]);

  useEffect(() => {
    fetchCustomNotifications(currentPage, pageSize);
  }, [currentPage, pageSize, fetchCustomNotifications]);

  const getDisplayDateTime = (scheduledAt, createdAt, isSent) => {
    const sourceDateTime = scheduledAt || createdAt;

    if (!sourceDateTime) {
      return {
        date: '-',
        time: '',
        isScheduled: false,
      };
    }

    const isPast = scheduledAt ? moment(scheduledAt).isBefore(moment()) : false;

    return {
      date: moment(sourceDateTime).format('DD MMM YYYY'),
      time: moment(sourceDateTime).format('hh:mm A'),
      isScheduled: Boolean(scheduledAt) && !isSent && !isPast,
    };
  };

  const toggleRowExpansion = (id) => {
    setExpandedRows((prev) => {
      return prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id];
    });
  };

  // Handle keyboard events for accessibility
  const handleKeyDown = (e, callback) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback();
    }
  };

  // Ã¢Â­Â UPDATED: Conditional styling based on isDrawer prop
  const containerStyle = isDrawer
    ? {
        position: 'fixed',
        right: 0,
        top: 0,
        width: '70%',
        height: '100vh',
        background: '#fff',
        boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1000,
        fontFamily: "'Work Sans', sans-serif",
      }
    : {
        width: '100%',
        height: '100%',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: "'Work Sans', sans-serif",
      };

  /* eslint-disable no-nested-ternary */
  return (
    <div
      style={containerStyle}
      className={
        isDrawer
          ? 'notification-static-drawer custom-notification-static-drawer'
          : 'analytics-custom-notification'
      }
    >
      {/* Content */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '15px' }}>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '40px',
            }}
          >
            <Loader />
          </div>
        ) : error ? (
          <p style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
            {error}
          </p>
        ) : notifications.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            No notifications found
          </p>
        ) : (
          <>
            <div className="analytics-mobile-list custom-notification-mobile-list">
              {notifications.map((item, index) => {
                const { date, time, isScheduled } = getDisplayDateTime(
                  item.scheduledAt,
                  item.createdAt,
                  item.isSent,
                );
                const serialNo = (currentPage - 1) * pageSize + index + 1;

                const isMobileExpanded = expandedMobileCardId === item.id;

                return (
                  <div
                    className="analytics-mobile-card"
                    key={`mobile-${item.id}`}
                  >
                    <div className="analytics-mobile-card__summary">
                      <div className="analytics-mobile-card__identity">
                        <div className="analytics-mobile-card__name">
                          {item.title || '-'}
                        </div>
                        <div className="analytics-mobile-card__meta">
                          {`S.No ${serialNo} | ${date}`}
                        </div>
                        <div className="analytics-mobile-card__meta">
                          {time}
                          {isScheduled ? (
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                marginLeft: '8px',
                                padding: '2px 8px',
                                borderRadius: '999px',
                                background: '#fff3cd',
                                color: '#856404',
                                fontSize: '10px',
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                letterSpacing: '0.02em',
                                verticalAlign: 'middle',
                              }}
                            >
                              Scheduled
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="analytics-mobile-card__aside">
                        <span className="analytics-mobile-card__pill muted">
                          {item.platformType || '-'}
                        </span>
                        <div className="analytics-mobile-card__tools">
                          {item.image && item.image.trim() !== '' ? (
                            <button
                              type="button"
                              className="analytics-mobile-card__icon-btn"
                              onClick={() => window.open(item.image, '_blank')}
                            >
                              Image
                            </button>
                          ) : null}
                          <button
                            type="button"
                            className={`analytics-mobile-card__expand-toggle ${
                              isMobileExpanded ? 'is-open' : ''
                            }`}
                            onClick={() => {
                              setExpandedMobileCardId((prevId) => {
                                return prevId === item.id ? null : item.id;
                              });
                            }}
                            aria-expanded={isMobileExpanded}
                            aria-label={
                              isMobileExpanded
                                ? 'Collapse notification details'
                                : 'Expand notification details'
                            }
                          >
                            <FaChevronDown />
                          </button>
                        </div>
                      </div>
                    </div>

                    {isMobileExpanded ? (
                      <div className="analytics-mobile-card__detail-list">
                        <div className="analytics-mobile-card__detail-row">
                          <span className="analytics-mobile-card__detail-label">
                            Message
                          </span>
                          <button
                            type="button"
                            className={`analytics-mobile-card__detail-value analytics-mobile-card__message ${
                              expandedRows.includes(item.id)
                                ? 'is-expanded'
                                : ''
                            }`}
                            onClick={() => toggleRowExpansion(item.id)}
                          >
                            {item.message || '-'}
                          </button>
                        </div>
                        <div className="analytics-mobile-card__stats-grid">
                          <div>
                            <span>Delivered</span>
                            <strong>{item.stats.delivered}</strong>
                          </div>
                          <div>
                            <span>Opened</span>
                            <strong>{item.stats.opened}</strong>
                          </div>
                          <div>
                            <span>Seen</span>
                            <strong>{item.stats.seen}</strong>
                          </div>
                          <div>
                            <span>Dismissed</span>
                            <strong>{item.stats.dismissed}</strong>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
            <div
              className="analytics-desktop-table"
              style={{ overflowX: 'auto' }}
            >
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontSize: '13px',
                }}
              >
                <thead>
                  <tr style={{ background: '#f1f3f5' }}>
                    <th style={headerStyle}>S.No.</th>
                    <th style={headerStyle}>Date</th>
                    <th style={headerStyle}>Title</th>
                    <th style={headerStyle}>Message</th>
                    <th style={headerStyle}>
                      Stats
                      <span
                        title={statsTooltip}
                        aria-label="Stats info"
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginLeft: '6px',
                          width: '16px',
                          height: '16px',
                          borderRadius: '50%',
                          background: '#ffe8a3',
                          color: '#6b4f00',
                          fontSize: '11px',
                          fontWeight: 700,
                          cursor: 'help',
                        }}
                      >
                        i
                      </span>
                    </th>
                    <th style={headerStyle}>Image</th>
                    <th style={headerStyle}>Platform</th>
                  </tr>
                </thead>
                <tbody>
                  {notifications.map((item, index) => {
                    const { date, time, isScheduled } = getDisplayDateTime(
                      item.scheduledAt,
                      item.createdAt,
                      item.isSent,
                    );
                    const serialNo = (currentPage - 1) * pageSize + index + 1;

                    return (
                      <tr
                        key={item.id}
                        style={{
                          borderBottom: '1px solid #e9ecef',
                          background: index % 2 === 0 ? '#fff' : '#fafafa',
                        }}
                      >
                        <td style={cellStyle}>{serialNo}</td>
                        <td style={cellStyle}>
                          <div
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '6px',
                              alignItems: 'center',
                            }}
                          >
                            <div style={{ whiteSpace: 'nowrap' }}>{date}</div>
                          </div>
                          {time ? (
                            <div
                              style={{
                                marginTop: '2px',
                                fontSize: '12px',
                                color: '#6c757d',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                              }}
                            >
                              {time}
                              {isScheduled ? (
                                <span
                                  style={{
                                    padding: '2px 8px',
                                    borderRadius: '999px',
                                    background: '#fff3cd',
                                    color: '#856404',
                                    fontSize: '10px',
                                    fontWeight: 700,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.02em',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Scheduled
                                </span>
                              ) : null}
                            </div>
                          ) : null}
                        </td>
                        <td style={{ ...cellStyle, fontWeight: 500 }}>
                          {item.title}
                        </td>
                        <td style={{ ...cellStyle, maxWidth: '250px' }}>
                          <button
                            type="button"
                            style={{
                              maxHeight: expandedRows.includes(item.id)
                                ? 'none'
                                : '60px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: expandedRows.includes(item.id)
                                ? 'unset'
                                : 3,
                              WebkitBoxOrient: 'vertical',
                              cursor: 'pointer',
                              border: 'none',
                              background: 'transparent',
                              padding: 0,
                              textAlign: 'left',
                              width: '100%',
                              font: 'inherit',
                              color: 'inherit',
                            }}
                            onClick={() => toggleRowExpansion(item.id)}
                            onKeyDown={(e) =>
                              handleKeyDown(e, () =>
                                toggleRowExpansion(item.id),
                              )
                            }
                            title="Click to expand/collapse"
                          >
                            {item.message}
                          </button>
                        </td>
                        <td style={cellStyle}>
                          <div style={{ fontSize: '13px' }}>
                            <div>
                              <strong>Delivered:</strong> {item.stats.delivered}
                            </div>
                            <div>
                              <strong>Opened:</strong> {item.stats.opened}
                            </div>
                            <div>
                              <strong>Dismissed:</strong> {item.stats.dismissed}
                            </div>
                            <div>
                              <strong>Seen:</strong> {item.stats.seen}
                            </div>
                          </div>
                        </td>
                        <td style={{ ...cellStyle, textAlign: 'center' }}>
                          {item.image && item.image.trim() !== '' ? (
                            <button
                              type="button"
                              onClick={() => window.open(item.image, '_blank')}
                              onKeyDown={(e) =>
                                handleKeyDown(e, () =>
                                  window.open(item.image, '_blank'),
                                )
                              }
                              style={{
                                border: 'none',
                                background: 'transparent',
                                padding: 0,
                                cursor: 'pointer',
                              }}
                            >
                              <img
                                src={item.image}
                                alt={item.title}
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  objectFit: 'cover',
                                  borderRadius: '4px',
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            </button>
                          ) : (
                            <span style={{ color: '#999', fontSize: '11px' }}>
                              No Image
                            </span>
                          )}
                        </td>
                        <td style={cellStyle}>
                          <span
                            style={{
                              padding: '4px 8px',
                              borderRadius: '4px',
                              background:
                                item.platformType === 'WEB'
                                  ? '#e3f2fd'
                                  : item.platformType === 'MOBILE'
                                    ? '#f3e5f5'
                                    : '#fff3e0',
                              color:
                                item.platformType === 'WEB'
                                  ? '#1565c0'
                                  : item.platformType === 'MOBILE'
                                    ? '#6a1b9a'
                                    : '#e65100',
                              fontSize: '11px',
                              fontWeight: 500,
                            }}
                          >
                            {item.platformType}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {totalPages > 0 && (
                <div className="d-flex mt-3 align-items-center justify-content-end">
                  <span className="text-active text-nowrap f-12">
                    {currentPage} of {totalPages}
                  </span>
                  <select
                    className="page-select form-select table-select f-12 fw-normal mx-3 d-inline-block"
                    value={pageSize}
                    onChange={(e) => {
                      const nextSize = Number(e.target.value);
                      setCurrentPage(1);
                      setPageSize(nextSize);
                    }}
                  >
                    {[10, 20, 30, 40, 50].map((size) => (
                      <option key={size} value={size}>
                        {size} per page
                      </option>
                    ))}
                  </select>
                  <div className="pagination">
                    <button
                      type="button"
                      onClick={() => setCurrentPage(1)}
                      disabled={currentPage <= 1}
                    >
                      {'<<'}
                    </button>
                    <button
                      type="button"
                      onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                      disabled={currentPage === 1}
                    >
                      {'<'}
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        setCurrentPage((p) => Math.min(totalPages, p + 1))
                      }
                      disabled={currentPage >= totalPages}
                    >
                      {'>'}
                    </button>
                    <button
                      type="button"
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={currentPage >= totalPages}
                    >
                      {'>>'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomNotificationTable;
